import React from "react";

export interface BannerContextType {
  hideAwardBanner: boolean;
  setHideAwardBanner: (_: boolean) => void;
}

export const BannerContext = React.createContext<BannerContextType>(null!);
